const Listing = () => import('../../components/Log/List')

export default {
    path: 'logs',
    redirect: 'logs',
    component: {
        template: '<router-view></router-view>',
    },
    name: 'logs',
    meta: {'permissions': 'view-logs'},
    children: [
        {
            path: '/',
            component: Listing,
        },
    ],
};
